import useBizNode from '../../useBizNode.mjs'
import parseMap from '../../scripts/parseMap.mjs'
import readProject from '../readProject.mjs'

export default (pkid, type) => {
    const BizNode = useBizNode()

    return async () => {
        const mapData = await BizNode[type].readHierarchyMap({pkid})
        const initData = parseMap(mapData)
        const project = await readProject(initData.data.prjId)
        Object.assign(initData.data, project)
        return initData
    }
}
